import React, { useState } from 'react'
import Typography from '../../../../global/typography'
import WrapperImage from '../../../../global/wrapperImage'
import LeadershipModal from '../leadershipModal'
import {
  BioCardContent,
  BioCardFooter,
  BioCardHolder,
  BioCardImage,
  BioCardQuote,
  BioCardWrapper,
  SocialMediaItem,
} from './style'

const LeadershipBio = (props: any) => {
  const {
    headshot,
    miniBio,
    firstName,
    lastName,
    role,
    twitterProfile,
    linkedInProfile,
    microcopy,
  } = props

  const image = headshot.image
  const fullName = `${firstName} ${lastName}`

  const [modalOpen, setModalOpen] = useState(false)
  const [modalData, setModalData] = useState({})

  const openModal = () => {
    if (!miniBio) {
      return
    }

    setModalData({
      fullName,
      role,
      miniBio,
      twitterProfile,
      linkedInProfile,
      image: image?.file?.url ? image.file.url : null,
      microcopy,
    })
    setModalOpen(true)
  }

  const closeModal = () => setModalOpen(false)

  return (
    <BioCardHolder hasMiniBio={miniBio}>
      <BioCardWrapper className="BioCardWrapper" data-cy="BioCardWrapper" onClick={openModal}>
        {image && image?.file?.url && (
          <BioCardImage data-cy="BioCardImage">
            <WrapperImage src={image.file.url} />
            {miniBio && <BioCardQuote className="BioCardQuote-Block" />}
          </BioCardImage>
        )}
        {fullName && (
          <BioCardContent className="BioCardContent-FullName">
            <Typography className="BioCardContent-FullName-Label" type="header6">
              {fullName}
            </Typography>
          </BioCardContent>
        )}
        {role && (
          <BioCardContent className="BioCardContent-Role">
            <Typography type="bodyXS">{role}</Typography>
          </BioCardContent>
        )}
      </BioCardWrapper>
      {(twitterProfile || linkedInProfile) && (
        <BioCardFooter>
          {twitterProfile && (
            <a href={twitterProfile} target="_blank">
              <SocialMediaItem className="BioCardFooter-TwitterProfile" />
            </a>
          )}
          {linkedInProfile && (
            <a href={linkedInProfile} target="_blank">
              <SocialMediaItem className="BioCardFooter-LinkedInProfile" />
            </a>
          )}
        </BioCardFooter>
      )}

      <LeadershipModal onClose={closeModal} open={modalOpen} data={modalData} />
    </BioCardHolder>
  )
}

export default LeadershipBio
